import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SectionBannerComponent } from '../../shared/section-banner/section-banner.component';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-not-found',
  standalone: true,
  imports: [SectionBannerComponent,ImageConverterPipe, TranslateModule],
  templateUrl: './error-not-found.component.html',
  styleUrl: './error-not-found.component.scss'
})

export class ErrorNotFoundComponent {
constructor(public router: Router) {}
}
